module.exports = __webpack_public_path__ + "img/img7.adbb86ca.jpg";